import styled from 'styled-components';

export const LabelWrapper = styled.label`
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
`;
